import { useEffect, useState } from 'react';
import { Paciente } from '../services/mockData';
import { useAuth } from '../contexts/AuthContext';
import { getPacientesComBaixaAdesao } from '../services/dataService';

export function useAlertas() {
  const { user } = useAuth();
  const [alertas, setAlertas] = useState<Paciente[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      if (!user) {
        if (isMounted) {
          setAlertas([]);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const pacientesComAlerta = await getPacientesComBaixaAdesao(user.uid);
        if (isMounted) {
          setAlertas(pacientesComAlerta);
        }
      } catch (err) {
        if (isMounted) {
          setError('Não foi possível carregar os alertas.');
          setAlertas([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, [user]);

  return { alertas, loading, error };
}

